import { apiClient } from '@/shared/services/client'
import type {
  VideoSeguimiento,
  VideoSeguimientosPaginados,
  VideoSeguimientoCreateInput,
  ReporteVisualizaciones,
  LaboratorioOption,
} from '../types'

const SEGUIMIENTOS_URL = '/visualizaciones/seguimientos'
const REPORTES_URL = '/visualizaciones'

export const visualizacionesApi = {
  async listarSeguimientos(params?: {
    laboratorio_id?: number
    activo?: boolean
    search?: string
    page?: number
    page_size?: number
  }): Promise<VideoSeguimientosPaginados> {
    const { data } = await apiClient.get<VideoSeguimientosPaginados>(`${SEGUIMIENTOS_URL}/`, {
      params,
    })
    return data
  },

  async crearSeguimiento(payload: VideoSeguimientoCreateInput): Promise<VideoSeguimiento> {
    const { data } = await apiClient.post<VideoSeguimiento>(`${SEGUIMIENTOS_URL}/`, payload)
    return data
  },

  async eliminarSeguimiento(id: number): Promise<void> {
    await apiClient.delete(`${SEGUIMIENTOS_URL}/${id}/`)
  },

  async obtenerReporte(
    id: number,
    params?: { desde?: string; hasta?: string; incluir_usuarios?: boolean },
  ): Promise<ReporteVisualizaciones> {
    const { data } = await apiClient.get<ReporteVisualizaciones>(
      `${REPORTES_URL}/${id}/reporte/`,
      { params },
    )
    return data
  },

  async listarLaboratorios(): Promise<LaboratorioOption[]> {
    // Mismo origen que el modal de creación de registros: grupos marcados como laboratorio.
    const { data } = await apiClient.get<LaboratorioOption[]>('/group-extensions/laboratorios/')
    return data
  },

  async descargarReporteExcel(
    id: number,
    params?: { desde?: string; hasta?: string },
  ): Promise<void> {
    const { data } = await apiClient.get(`${REPORTES_URL}/${id}/reporte/excel/`, {
      params,
      responseType: 'blob',
    })
    const url = window.URL.createObjectURL(data as Blob)
    const link = document.createElement('a')
    link.href = url
    const hoy = new Date().toISOString().slice(0, 10)
    link.download = `visualizaciones_${id}_${hoy}.xlsx`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  },
}
